import { GfsOfferObjectPage } from "@/services/backend/gfs/offer/components/offer-object-page";

export default function GfsOfferObjectRoute() {
  return <GfsOfferObjectPage />;
}
